<template>
    <div class="card shadow-sm mb-3 bg-light">
        <div class="card-header-item p-1" :class="headerColor">
            <div class="row px-1">
                <div class="col-10">
                    {{ event.created_at | moment('Do MMMM Y') }} -
                    {{ event.created_by.name }}
                </div>

                <div class="col-2 text-right">
                    <div v-if="editing">
                        <a
                            :key="'save' + event.id"
                            href="#"
                            title="Enregistrer"
                            class="ml-1"
                            @click="update"
                        >
                            <span style="font-size: 14px; color: white"
                                ><i class="fas fa-save fa-fw"></i
                            ></span>
                        </a>
                        <a
                            :key="'close' + event.id"
                            href="#"
                            title="Annuler"
                            class="ml-1"
                            @click="close"
                        >
                            <span style="font-size: 14px; color: white"
                                ><i class="fas fa-times fa-fw"></i
                            ></span>
                        </a>
                    </div>
                    <div v-else>
                        <a
                            v-if="event.can_edit"
                            :key="'edit' + event.id"
                            href="#"
                            title="Modifier"
                            class="ml-1"
                            @click="editEvent"
                        >
                            <span style="font-size: 14px; color: white"
                                ><i class="fas fa-pencil fa-fw"></i
                            ></span>
                        </a>
                        <a
                            v-if="event.can_edit"
                            :key="'delete' + event.id"
                            href="#"
                            title="Supprimer"
                            class="ml-1"
                            @click="confirmDelete"
                        >
                            <span style="font-size: 14px; color: white"
                                ><i class="fas fa-trash-alt fa-fw"></i
                            ></span>
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <div class="card-body p-3">
            <p v-if="!editing" class="mb-0" @click="editEvent">
                {{ event.description }}
            </p>
            <b-form-textarea
                v-if="editing"
                id="textarea"
                v-model="form.description"
                rows="3"
                max-rows="6"
                class="mb-2"
                @change="update"
            ></b-form-textarea>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import DataUpdater from '../../../../dashboard/mixins/DataUpdater'

export default {
    name: 'HistoryElementShow',

    mixins: [DataUpdater],

    props: {
        event: {},
    },

    data() {
        return {
            form: {
                description: '',
            },
            editing: false,
            ISODateTime: '',
            billable: false,
        }
    },

    mounted() {
        this.editing = this.storeEditing
        this.form.description = this.event.description
        if (this.isTask) {
            this.billable = this.event.billable === 1
            this.form.assigned_to = this.event.assigned_to.id
            this.ISODateTime = this.event.deadline_date
        }
    },

    methods: {
        editEvent() {
            if (this.event.can_edit) {
                this.form.description = this.event.description
                this.editing = true
            }
        },

        close() {
            this.editing = false
            this.$store.commit('browsing/RESET_EDITING')
        },

        async update() {
            this.form.client_id = this.clientId
            if (this.isTask) {
                await this.saveTask()
            } else {
                await this.saveEvent()
            }
            this.updateData()
        },

        async saveEvent() {
            try {
                await axios.put(
                    `/clientEvents/event/${this.event.id}`,
                    this.form
                )
                this.close()
                this.updateData()
            } catch (error) {
                console.log(error)
            }
        },

        async saveTask() {
            try {
                this.form.deadline_date = this.formattedDateTime
                this.form.billable = this.billable
                await axios.put(
                    `/clientEvents/task/${this.event.id}`,
                    this.form
                )
                this.close()
                this.updateData()
            } catch (error) {
                console.log(error)
            }
        },

        confirmDelete() {
            this.$bvModal
                .msgBoxConfirm(this.modalMessage, {
                    title: this.modalTitle,
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'OUI',
                    cancelTitle: 'NON',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        this.deleteEvent()
                    }
                })
                .catch((err) => {
                    // An error occurred
                })
        },

        async deleteEvent() {
            try {
                await axios.delete(`/clientEvents/${this.event.id}`)
                this.$parent.getItems()
            } catch (error) {
                console.log(error)
            }
        },
    },

    computed: {
        ...mapState({
            clientId: (state) => state.browsing.clientId,
            storeEditing: (state) => state.browsing.editing,
            options: (state) => state.data.options.accountingFirmUsers,
        }),

        billingSwitchTitle() {
            return this.billable ? 'Tâche facturable' : 'Tâche non facturable'
        },

        isTask() {
            return this.event.assigned_to !== null
        },

        formattedDateTime() {
            const dt = new Date(this.ISODateTime)
            const Y = dt.getFullYear()
            const m =
                dt.getMonth() + 1 < 10
                    ? `0${(dt.getMonth() + 1).toString()}`
                    : (dt.getMonth() + 1).toString()
            const d =
                dt.getDate() < 10
                    ? `0${dt.getDate().toString()}`
                    : dt.getDate().toString()
            const H =
                dt.getHours() < 10
                    ? `0${dt.getHours().toString()}`
                    : dt.getHours().toString()
            const i =
                dt.getMinutes() < 10
                    ? `0${dt.getMinutes().toString()}`
                    : dt.getMinutes().toString()
            return `${Y}-${m}-${d} ${H}:${i}`
        },

        billableLegend() {
            return this.event.billable ? 'facturable' : 'non facturable'
        },

        icon() {
            return this.isTask ? 'far fa-tasks' : 'far fa-history'
        },

        headerColor() {
            if (this.isTask) {
                if (this.event.late) {
                    return 'bg-danger'
                }
                if (this.event.soon) {
                    return 'bg-warning'
                }
                return ''
            }
            return ''
        },

        modalTitle() {
            return this.isTask
                ? "Suppression d'une tâche"
                : "Suppression d'un évènement"
        },

        modalMessage() {
            return this.isTask
                ? 'Etes-vous sûr·e de vouloir supprimer cette tâche ?'
                : 'Etes-vous sûr·e de vouloir supprimer cet évènement ?'
        },

        achievement() {
            if (this.isTask && !this.editing) {
                if (this.event.done) {
                    const achievementDate = this.$moment(
                        this.event.achievement_date
                    )
                    return `, réalisée par ${
                        this.event.assigned_to.name
                    } le ${achievementDate.format('Do MMMM YYYY')}`
                }
                const deadlineDate = this.$moment(this.event.deadline_date)
                return `, à réaliser par ${
                    this.event.assigned_to.name
                } avant le ${deadlineDate.format('Do MMMM')}`
            }
            return ''
        },
    },
}
</script>

<style scoped>
.card-header-item {
    background-color: #594f47;
    font-size: 12px;
    font-weight: bold;
    color: #fff;
}

.item-footer {
    font-weight: 400;
    font-style: italic;
    font-size: 12px;
    padding-right: 0;
}
</style>
